import micromagFree from '../assets/img/promotions/micromag_free.svg';
import periodeLibreImage from '../assets/img/promotions/periodelibre.png';

function isFromGoogle() {
    return (
        (typeof document !== 'undefined' ? document.referrer || location.search || '' : '').indexOf(
            'google.',
        ) !== -1
    );
}

// The consent is shown as a banner at the bottom of the screen for everyone when the
// `consentBanner` setting of the site is on (Panneau, Sites)
function isConsentBanner(settings) {
    const { consentBanner = false } = settings || {};
    return consentBanner === true;
}

function shouldBeBlocked(document, minInterest = 0.5, both = false) {
    const { stats = null, metadata } = document || {};
    const { sponsors } = metadata || {};
    const [sponsor = null] = sponsors || [];
    const isSponsored = sponsor !== null;
    if (isSponsored) {
        return false;
    }
    const { traffic, interest = 0 } = stats || {};
    const highTraffic = traffic === 'viral';
    const highInterest = interest > minInterest;
    return (both && highTraffic && highInterest) || (!both && (highTraffic || highInterest));
}

const promotions: Promotion[] = [
    {
        id: 'consent_notification',
        type: 'consent',
        placement: 'notification',
        force: true,
        priority: 101,
        site: 'urbania',
        title: null,
        description: null,
        loginDescription: '<h4>Connectez-vous ou créez un compte gratuit:</h4>',
        cookiesDescription: null,
        subscribeButtonLabel: 'Continuer',
        // cookiesButtonLabel: 'Acceptez les cookies',
        ssoOnly: true,
        check: ({ currentDocument = null, settings = null } = {}) =>
            isConsentBanner(settings) || (isFromGoogle() && !shouldBeBlocked(currentDocument)),
        sections: ['login', 'cookies'],
        trigger: {
            event: 'one',
            triggers: ['identify', 'pageview'],
            pageMatch: {
                notType: ['micromags', 'micromag', 'login', 'account', 'auth'],
            },
            delay: 2000,
            hasPage: true,
            identified: true,
            authenticated: false,
            consentGiven: null,
        },
    },

    {
        id: 'consent_modal',
        type: 'consent',
        placement: 'modal',
        force: true,
        priority: 100,
        site: 'urbania',
        title: 'Avant de continuer…',
        description: '<h4>Connectez-vous ou<br/>créez un compte gratuit et:</h4>',
        loginDescription:
            '<ul><li>Recevez des <strong>contenus exclusifs</strong> et personnalisés chaque semaine</li><li>Accédez à la <strong>prévente de billets</strong> pour nos événements</li><li><strong>Obtenez des rabais</strong> sur notre boutique et auprès des partenaires</li></ul>',
        cookiesDescription:
            '<p>Vous ne souhaitez pas créer un compte? Alright! Acceptez simplement les cookies pour accéder au contenu de notre site.</p>',
        subscribeButtonLabel: 'Continuer',
        check: ({ currentDocument = null, settings = null } = {}) =>
            !isConsentBanner(settings) && (!isFromGoogle() || shouldBeBlocked(currentDocument)),
        sections: ['login', 'cookies'],
        trigger: {
            event: 'one',
            triggers: ['identify', 'pageview'],
            pageMatch: {
                notType: ['micromags', 'micromag', 'login', 'account', 'auth'],
            },
            delay: 2000,
            hasPage: true,
            identified: true,
            authenticated: false,
            consentGiven: null,
        },
    },

    {
        id: 'consent_notification_france',
        type: 'consent',
        placement: 'notification',
        force: true,
        priority: 101,
        site: 'france',
        title: null,
        description: null,
        loginDescription: '<h4>Connectez-vous ou créez un compte gratuit :</h4>',
        cookiesDescription: null,
        subscribeButtonLabel: 'Continuer',
        ssoOnly: true,
        check: ({ settings = null } = {}) => isConsentBanner(settings),
        sections: ['login', 'cookies'],
        trigger: {
            event: 'one',
            triggers: ['identify', 'pageview'],
            pageMatch: {
                notType: ['micromags', 'micromag', 'login', 'account', 'auth'],
            },
            delay: 2000,
            hasPage: true,
            identified: true,
            authenticated: false,
            consentGiven: null,
        },
    },

    {
        id: 'consent',
        type: 'consent',
        placement: 'modal',
        force: true,
        priority: 100,
        site: 'france',
        title: 'Avant de continuer…',
        description:
            '<p><strong>URBANIA est un média indépendant et gratuit grâce à vous.</strong></p>',
        cookiesDescription:
            '<p>Vous pouvez accepter les cookies pour accéder au contenu de notre site.</p>',
        loginDescription:
            'Rejoignez la communauté URBANIA et recevez le meilleur de nos contenus, sélectionnés pour vous, toutes les deux semaines dans votre boîte mail.',
        subscribeButtonLabel: 'Continuer',
        check: ({ settings = null } = {}) => !isConsentBanner(settings),
        sections: ['login', 'cookies'],
        trigger: {
            event: 'one',
            triggers: ['identify', 'pageview'],
            pageMatch: {
                notType: ['micromags', 'micromag', 'login', 'account', 'auth'],
            },
            delay: 2000,
            hasPage: true,
            identified: true,
            authenticated: false,
            consentGiven: null,
        },
    },

    {
        id: 'subscribe_micromags',
        handle: 'subscribe_micromags',
        type: 'subscription',
        placement: 'notification',
        subscription: 'micromag',
        closeable: false,
        force: true,
        site: 'urbania',
        title: 'Abonnez-vous à URBANIA',
        description: null,
        image: {
            url: micromagFree,
        },
        theme: 'micromag',
        trigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                type: ['micromags'],
            },
        },
        closeTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                notType: ['micromags'],
            },
        },
    },

    {
        id: 'subscribe_micromags',
        handle: 'subscribe_micromags',
        type: 'subscription',
        placement: 'notification',
        subscription: 'micromag_france',
        closeable: false,
        force: true,
        site: 'france',
        title: 'Abonnez-vous à URBANIA',
        description: null,
        image: {
            url: micromagFree,
        },
        theme: 'micromag',
        trigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                type: ['micromags'],
            },
        },
        closeTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                notType: ['micromags'],
            },
        },
    },

    {
        id: 'subscribe_micromag_trailer',
        handle: 'subscribe_micromag_trailer',
        type: 'subscription',
        placement: 'notification',
        subscription: 'micromag',
        closeable: false,
        force: true,
        site: 'urbania',
        title: 'Abonnez-vous au Micromag',
        description: 'Et vous recevrez ce numéro samedi.',
        image: {
            url: micromagFree,
        },
        theme: 'micromag',
        trigger: {
            event: 'one',
            triggers: [
                // {
                //     event: 'pageview',
                //     once: false,
                //     delay: 2000,
                //     pageMatch: {
                //         type: ['micromag'],
                //         isTrailer: true,
                //     },
                // },
                {
                    event: 'video_play',
                    once: false,
                    delay: 2000,
                    pageMatch: {
                        type: ['micromag'],
                        isTrailer: true,
                    },
                },
            ],
        },
        closeTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                notType: ['micromag'],
            },
        },
    },

    {
        id: 'subscription_block_france',
        handle: 'subscription_block_france',
        type: 'subscription',
        placement: 'block',
        subscription: 'france',
        site: 'france',
        title: 'Abonnez-vous à la newsletter de URBANIA',
        description:
            'Et recevez tous les jeudis votre dose de contenus drôles et intelligents directement en intraveineuse dans votre boîte mail.',
        image: {
            url: 'https://cdn.urbania.ca/media/2024/12/icon-france-prof-1.png',
        },
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
        },
    },

    {
        id: 'subscription_block_urbania',
        handle: 'subscription_block_urbania',
        type: 'subscription',
        placement: 'block',
        subscription: 'urbania',
        site: 'urbania',
        title: 'Abonnez-vous à l’infolettre de URBANIA',
        description:
            'Et recevez, chaque semaine, nos contenus qui soulèvent les passions. Un pas de recul, sérieux ou non, sur l’actualité de la semaine.',
        image: {
            url: 'https://cdn.urbania.ca/media/2024/12/icon-urbania-hugo.png',
        },
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
        },
    },

    {
        id: 'subscription_block_periodelibre',
        handle: 'subscription_block_periodelibre',
        type: 'subscription',
        placement: 'block',
        subscription: 'periodelibre',
        site: 'urbania',
        title: 'Vous êtes atteint de FOMO ?',
        description: 'Chaque mois, recevez la liste des MEILLEURS événements en ville.',
        image: {
            url: periodeLibreImage,
        },
        priority: 10,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                brands: ['periode-libre'],
            },
        },
    },

    {
        id: 'subscription_block_mollo_parent_fun',
        handle: 'subscription_block_mollo_parent_fun',
        type: 'subscription',
        placement: 'block',
        subscription: 'mollo',
        site: 'urbania',
        title: 'Abonnez-vous à l’infolettre Mollo',
        description: 'Et recevez nos meilleurs contenus de type « parent-le-fun » chaque jeudi.',
        image: {
            url: 'https://cdn.urbania.ca/media/2024/08/Maman.png',
        },
        priority: 10,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                brands: ['mollo'],
            },
        },
    },
    {
        id: 'subscription_block_quatre95',
        handle: 'subscription_block_quatre95',
        type: 'subscription',
        placement: 'block',
        subscription: 'quatre95',
        site: 'urbania',
        title: 'Abonnez-vous à l’infolettre de Quatre95',
        description:
            'Et recevez nos meilleurs contenus chaque jeudi. Vous en aurez pour votre argent.',
        image: {
            url: 'https://cdn.urbania.ca/media/2024/12/icon-quatre95-hand.png',
        },
        priority: 10,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                brands: ['quatre95'],
            },
        },
    },

    {
        id: 'subscription_block_hugo_meunier',
        handle: 'subscription_block_hugo_meunier',
        type: 'subscription',
        placement: 'block',
        subscription: 'hugo-meunier',
        site: 'urbania',
        title: 'Vous êtes fan d’Hugo Meunier ?',
        description: 'Recevez un texto à chaque fois qu’il <s>fait du karaoké</s> sort un contenu',
        image: {
            url: 'https://images.urbania.ca/image/2024-08-06/90460-033504-filters(large).jpg',
        },
        priority: 100,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                authors: ['hugomeunier'],
            },
        },
    },
    {
        id: 'subscription_block_jean_bourbeau',
        handle: 'subscription_block_jean_bourbeau',
        type: 'subscription',
        placement: 'block',
        subscription: 'jean-bourbeau',
        site: 'urbania',
        title: 'Adepte des récits de Jean Bourbeau ?',
        description: 'Recevez une alerte par texto pour chacun de ses textes.',
        image: {
            url: 'https://images.urbania.ca/image/2024-08-06/90463-033648-filters(large).jpg',
        },
        priority: 100,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                authors: ['jeanbourbeau'],
            },
        },
    },

    {
        id: 'subscription_block_benoit_lelievre',
        handle: 'subscription_block_benoit_lelievre',
        type: 'subscription',
        placement: 'block',
        subscription: 'benoit-lelievre',
        site: 'urbania',
        title: 'Vous aimez tout ce que Ben écrit?',
        description: 'Recevez une alerte par texto pour chacun de ses textes.',
        image: {
            url: 'https://images.urbania.ca/image/2024-11-25/93937-015455-filters(large).jpg',
        },
        priority: 100,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                authors: ['benoitlelievre'],
            },
        },
    },
    {
        id: 'subscription_block_salome_maari',
        handle: 'subscription_block_salome_maari',
        type: 'subscription',
        placement: 'block',
        subscription: 'salome-maari',
        site: 'urbania',
        title: 'Fan des reportages de Salomé Maari ?',
        description: 'Recevez une alerte par texto pour chacun de ses textes.',
        image: {
            url: 'https://images.urbania.ca/image/2025-02-11/97041-104440-filters(large).jpg',
        },
        priority: 100,
        // theme: 'mollo',
        matchTrigger: {
            event: 'pageview',
            once: false,
            pageMatch: {
                authors: ['salome-maari'],
            },
        },
    },
    {
        id: 'access_micromag',
        handle: 'access_micromag',
        type: 'subscription',
        placement: 'modal',
        force: true,
        priority: 1,
        theme: 'full',
        title: 'Abonnez-vous<br/>pour continuer',
        site: 'urbania',
        description: 'Vous recevrez nos micromags gratuitement et en exclusivité chaque samedi.',
        titleLogin: 'Connectez-vous<br/>pour continuer',
        descriptionLogin: 'Vous aurez accès à tous les micromags en exclusivité.',
        subscriptions: 'micromag',
    },

    {
        id: 'access_micromag_create',
        handle: 'access_micromag_create',
        type: 'subscription',
        placement: 'modal',
        force: true,
        priority: 1,
        theme: 'full',
        title: 'Créez un compte<br/>pour continuer',
        buttonLabel: 'Continuer',
        site: 'urbania',
        description: 'Vous recevrez nos micromags gratuitement et en exclusivité chaque samedi.',
        titleLogin: 'Connectez-vous<br/>pour continuer',
        descriptionLogin: 'Vous aurez accès à tous les micromags en exclusivité.',
        subscriptions: 'micromag',
    },

    {
        id: 'access_micromag',
        handle: 'access_micromag',
        type: 'subscription',
        placement: 'modal',
        force: true,
        priority: 1,
        theme: 'full',
        title: 'Abonnez-vous<br/>pour continuer',
        site: 'france',
        description: 'Vous recevrez nos micromags gratuitement et en exclusivité tous les 3 mois.',
        titleLogin: 'Connectez-vous<br/>pour continuer',
        descriptionLogin: 'Vous aurez accès à tous les micromags en exclusivité.',
        subscriptions: 'micromag_france',
    },

    {
        id: 'access_all',
        handle: 'access_all',
        type: 'subscription',
        placement: 'modal',
        force: true,
        priority: 1,
        theme: 'full',
        title: 'Abonnez-vous<br/>pour continuer',
        description:
            'Vous aurez accès à tous nos contenus sans restriction et recevrez nos contenus en exclusivité.',
        titleLogin: 'Connectez-vous<br/>pour continuer',
        descriptionLogin: 'Vous aurez accès à tous les contenus sans restriction.',
    },

    {
        id: 'access_viral',
        handle: 'access_viral',
        type: 'subscription',
        placement: 'modal',
        force: true,
        priority: 1,
        theme: 'full',
        title: 'Abonnez-vous<br/>pour continuer',
        description:
            'Vous aurez accès à tous nos contenus sans restriction et recevrez nos contenus en exclusivité.',
        titleLogin: 'Connectez-vous<br/>pour continuer',
        descriptionLogin: 'Vous aurez accès à tous les contenus sans restriction.',
        check: ({ currentDocument = null } = {}) => shouldBeBlocked(currentDocument, 0.6, true),
        trigger: {
            event: 'document_progress',
            pageMatch: {
                notType: ['micromags', 'micromag', 'login', 'account', 'auth'],
            },
            hasPage: true,
            identified: true,
            authenticated: false,
            documentProgress: 0.2,
        },
    },

    // {
    //     id: 'subscribe_button',
    //     type: 'button',
    //     placement: 'notification',
    //     closeable: false,
    //     force: true,
    //     callToAction: {
    //         label: 'S’abonner',
    //         url: '/abonnement',
    //     },
    //     trigger: {
    //         event: 'pageview',
    //         pageMatch: {
    //             type: ['micromags']
    //         },
    //     },
    // },

    // {
    //     id: 'quatre95_sondage_2024',
    //     site: 'urbania',
    //     placement: 'notification',
    //     theme: 'quatre95',
    //     priority: 0,
    //     trigger: {
    //         event: 'pageview',
    //         pageMatch: {
    //             brands: ['quatre95'],
    //         },
    //         delay: 2000,
    //     },
    //     title: 'Courez la chance de gagner 100$',
    //     description:
    //         'en répondant à un sondage sur le contenu Quatre95. <strong>Ça ne vous prendra que quelques minutes, promis.</strong>',
    //     image: {
    //         url: q95Sondage,
    //     },
    //     url: 'https://cube.ca1.qualtrics.com/jfe/form/SV_d1kjCoUlLD7oNPU?Source=SW',
    //     callToAction: {
    //         type: 'button',
    //         label: 'Je participe',
    //         external: true,
    //     },
    // },

    // {
    //     id: 'mollogotchi',
    //     // type: 'subscription',
    //     placement: 'notification',
    //     force: true,
    //     // theme: 'full',
    //     // subscription: 'micromag',
    //     image: {
    //         url: '',
    //     },
    //     title: 'Mollogotchi',
    //     description: 'Essayez Mollogotchi',
    //     trigger: {
    //         event: 'one',
    //         triggers: [
    //             {

    //             }
    //         ]
    //     },
    // },
];

export default promotions;
